import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Modal from 'material-ui/Modal';

import Icon from '../../../../Icon';
import Button from '../../../../Button';

import styles from './styles.module.styl';

const SubscriptionInfoPopup = ({ opened, onClose }) => {
  const { formatMessage } = useIntl();

  const buttonTitle = formatMessage({ id: 'common.gotIt' });

  const message = formatMessage({
    id: 'profile.payment.subscriptionMessage',
  });

  return (
    <Modal open={opened} onClose={onClose}>
      <div className={styles.content}>
        <div className={styles.info}>
          <Icon name="information" size={48} />
        </div>
        <div className={styles.message}>{message}</div>
        <div className={styles.footer}>
          <Button color="primary" onClick={onClose} className={styles.button}>
            {buttonTitle}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

SubscriptionInfoPopup.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SubscriptionInfoPopup;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/Payments/SubscriptionInfoPopup/index.jsx